import { gridPaths } from '@/shared/hooks';
import { createFeatureGridConfig, type GridConfig } from '@/ui/composites/grid/gridConfigFactory';
import { fetchReleasesGrid } from './gridQuery';
import type { GridFilterModel, GridSortModel } from '@/ui/primitives';
import type { ReleaseListItemDto } from '@flowqa/shared';

export const releasesGridConfig = ({
  initialSortModel,
  initialFilterModel,
  persistKey,
  syncStateToUrl = false,
  orgId,
  projectId,
}: {
  initialSortModel?: GridSortModel;
  initialFilterModel?: GridFilterModel;
  persistKey?: string | null;
  syncStateToUrl?: boolean;
  orgId?: string | null;
  projectId?: string | null;
} = {}): GridConfig<ReleaseListItemDto> =>
  createFeatureGridConfig<ReleaseListItemDto>(
    {
      path: gridPaths.releases,
      queryFn: async (input) => await fetchReleasesGrid(projectId, orgId, input),
      noRowsText: 'No releases found',
      defaultPersistKey: 'releases',
      defaultSortModel: [{ field: 'plannedFor', sort: 'asc' }],
    },
    { initialSortModel, initialFilterModel, persistKey, syncStateToUrl },
  );

export type ReleasesGridConfig = ReturnType<typeof releasesGridConfig>;
